import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import type { DonViTinh, QuyDoiDonViTinhChung } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<QuyDoiDonViTinhChung>[] => {
  return [
    {
      field: 'dvt',
      headerName: 'Đvt',
      width: 150,
      renderCell: (params: DataTableRenderCellParams<QuyDoiDonViTinhChung>) => {
        return params.row.dvt_data?.dvt || params.row.dvt || '';
      }
    },
    {
      field: 'he_so',
      headerName: 'Hệ số',
      width: 200,
      type: 'number'
    },
    {
      field: 'dvt0',
      headerName: 'Đvt quy đổi',
      width: 150,
      renderCell: (params: DataTableRenderCellParams<QuyDoiDonViTinhChung>) => {
        return params.row.dvt0_data?.dvt || params.row.dvt0 || '';
      }
    }
  ];
};

export const unitColumns: DataTableColumn<DonViTinh>[] = [
  {
    field: 'dvt',
    headerName: 'Đvt',
    width: 150
  },

  {
    field: 'ten_dvt',
    headerName: 'Tên đơn vị tính',
    width: 200
  }
];
